import React, { forwardRef } from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  className = '',
  label,
  error,
  helperText,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-1654">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1655">
            {label}
          </label>}
        <textarea ref={ref} className={`w-full px-3 py-2 border ${error ? 'border-red-500' : 'border-gray-300'} rounded-sm text-sm font-normal focus:outline-none focus:ring-2 focus:ring-greenback focus:border-transparent resize-none ${className}`} {...props} data-id="element-1656" />
        {error && <p className="mt-1 text-sm text-red-600" data-id="element-1657">{error}</p>}
        {helperText && !error && <p className="mt-1 text-sm text-gray-500" data-id="element-1658">{helperText}</p>}
      </div>;
});
Textarea.displayName = 'Textarea';